import { Injectable } from '@angular/core';
import { NotificationData } from './notification.service';
import { OrdersService } from '../orders/services/orders.service';
import { GateService } from './gate.service';
import {
  isMultiEligibleMembershipRedeemCompleted,
  isPostPurchaseLprMembershipActivation,
  resolveNotificationLaneId,
  resolveNotificationLocationId,
  shouldSkipActiveSubscriptionModal,
} from '../shared/utils/gate-lane.util';

@Injectable({
  providedIn: 'root',
})
export class ActiveSubscriptionGateService {
  constructor(
    private readonly ordersService: OrdersService,
    private readonly gateService: GateService
  ) {}

  /**
   * Skip Active subscription modal when the lane/gate path already handled the visit,
   * when this is the first wash from an LPR/image membership purchase (payment success
   * already shown), or when the attendant just redeemed from multi-eligible.
   */
  tryConsumeWithoutModal(notification: NotificationData): boolean {
    if (isPostPurchaseLprMembershipActivation(notification)) {
      this.ordersService.refreshOrders();
      return true;
    }

    // Multi-eligible confirm already opened the gate via completeActiveSubscription —
    // do not open the gate again or stack Active subscription on the toast.
    if (isMultiEligibleMembershipRedeemCompleted(notification)) {
      this.ordersService.refreshOrders();
      return true;
    }

    if (!shouldSkipActiveSubscriptionModal(notification)) {
      return false;
    }

    const data = notification.data as Record<string, any> | undefined;
    const locationId = resolveNotificationLocationId(data);
    const laneId = resolveNotificationLaneId(data);

    this.gateService.openLaneGate(locationId, laneId).subscribe({
      next: () => this.ordersService.refreshOrders(),
      error: () => this.ordersService.refreshOrders(),
    });

    return true;
  }
}
